import Checkout from "@/views/checkout/checkout.vue";
import OrderPlaced from "@/views/checkout/orderPlaced.vue";

export default [
    {
        path: "/checkout",
        name: "checkout",
        title: 'Checkout',
        component: Checkout,
        children: [
            {
                path: '',
                redirect: '/checkout/cart',
            },
            {
                path: 'cart',
                name: 'checkout-cart',
                component: Checkout,
            },
            {
                path: 'orderform',
                name: 'checkout-orderform',
                component: Checkout
            },
            {
                path: 'orderform/profile',
                name: 'checkout-orderform-profile',
                component: Checkout
            },
            {
                path: 'orderform/payment',
                name: 'checkout-orderform-payment',
                component: Checkout
            },
        ]
    },
    {
        path: "/orderplaced",
        name: "orderplaced",
        title: 'Pedido confirmado',
        component: OrderPlaced,
    }
];
